import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _get from "@babel/runtime/helpers/get";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { DragSourceTypes } from '@beefco/types/bridge';
import { DragSourceHandler } from "./base/DragSourceHandler";
export var ComponentDragSourceHandler = /*#__PURE__*/function (_DragSourceHandler) {
  _inherits(ComponentDragSourceHandler, _DragSourceHandler);
  var _super = _createSuper(ComponentDragSourceHandler);
  function ComponentDragSourceHandler(dragStatus) {
    var _thisSuper, _thisSuper2, _thisSuper3, _this;
    _classCallCheck(this, ComponentDragSourceHandler);
    _this = _super.call(this);
    _this.dragStatus = dragStatus;
    _defineProperty(_assertThisInitialized(_this), "handleDragMouseDown", function (event, args) {
      _get((_thisSuper = _assertThisInitialized(_this), _getPrototypeOf(ComponentDragSourceHandler.prototype)), "handleDragMouseDown", _thisSuper).call(_thisSuper, event, args);
      _this.dragStatus.emitDragMouseDown(args.componentId, DragSourceTypes.COMPONENT);
    });
    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (event) {
      _get((_thisSuper2 = _assertThisInitialized(_this), _getPrototypeOf(ComponentDragSourceHandler.prototype)), "handleDragStart", _thisSuper2).call(_thisSuper2, event);
      _this.dragStatus.emitComponentDragStart();
    });
    _defineProperty(_assertThisInitialized(_this), "handleDragEnd", function (event) {
      _this.dragStatus.emitDragMouseUp();
      _this.dragStatus.emitComponentDragEnd();
      _get((_thisSuper3 = _assertThisInitialized(_this), _getPrototypeOf(ComponentDragSourceHandler.prototype)), "handleDragEnd", _thisSuper3).call(_thisSuper3, event);
    });
    return _this;
  }
  return _createClass(ComponentDragSourceHandler);
}(DragSourceHandler);